import { Injectable } from "@angular/core";
import { BaseServiceService } from "../base-service/base-service.service";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { COMMON } from "../../app.constants";
@Injectable({
  providedIn: "root",
})
export class CommonService extends BaseServiceService {
  constructor(public http: HttpClient) {
    super(http);
  }

  sendOtp(reqObj) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = COMMON.SEND_OTP;
        this.postCall(apiName, reqObj).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            // console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        // console.log("logError ", error);
        reject(error);
      }
    });
  }
  sendBothOtp(reqObj) {
    return new Promise((resolve, reject) => {
      try {
        const apiName = COMMON.SEND_BOTH_OTP;
        this.postCall(apiName, reqObj).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            // console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        // console.log("logError ", error);
        reject(error);
      }
    });
  }
  validateBothOtp(reqObj) {
    return new Promise((resolve, reject) => {
      try {
        const apiName = COMMON.VALIDATE_BOTH_OTP;
        this.postCall(apiName, reqObj).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            // console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        // console.log("logError ", error);
        reject(error);
      }
    });
  }

  getWhosWhoInfo() {
    return new Promise((resolve, reject) => {
      try {
        let apiName = "api/home/getWhosWhoInfo";
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  getHomePageInfo() {
    return new Promise((resolve, reject) => {
      try {
        let apiName = "api/home/getHomePageInfo";
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  getLastBuildAndReleases() {
    return new Promise((resolve, reject) => {
      try {
        let apiName = COMMON.GET_LAST_BUILD_AND_RELEASES;
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  validateOtp(reqObj) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = COMMON.VALIDATE_OTP;
        this.postCall(apiName, reqObj).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            //console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        //console.log("logError ", error);
        reject(error);
      }
    });
  }

  getApplicationDetails(reqObj) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = COMMON.GET_APPLICATION_DETAILS;
        this.postCall(apiName, reqObj).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            // console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        //console.log("logError ", error);
        reject(error);
      }
    });
  }

  getInternalSourcing(reqObj) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = COMMON.INTERNAL_SOURCING_DATA;
        this.postCall(apiName, reqObj).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            // console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        //console.log("logError ", error);
        reject(error);
      }
    });
  }

  getInternalSourcingRegisterUser(reqObj) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = COMMON.INTERNAL_SOURCING_DATA_REGISTER;
        this.postCall(apiName, reqObj).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            // console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        //console.log("logError ", error);
        reject(error);
      }
    });
  }
  convergencePatnerCategory() {
    return new Promise((resolve, reject) => {
      try {
        let apiName = 'api/users/getConvergencePatnerCategory';
        this.getCall(apiName).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }
  getDRPInternalSourcingUserByDistrict(id) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = COMMON.GET_INTERNAL_SOURCINGBY_DISTICT + id;
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }
  getDRPInternalSourcingUserByUserId(id) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = COMMON.GET_INTERNAL_SOURCINGBY_USERID + id;
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }
  getApplicationDetailsV2(applicationNo) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = COMMON.GET_APPLICATION_DETAILS + "/" + applicationNo;
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            //console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        // console.log("logError ", error);
        reject(error);
      }
    });
  }

  downloadLandingBankReport() {
    return new Promise((resolve, reject) => {
      try {
        let apiName = COMMON.DOWNLOAD_LANDING_BANK_REPORT;
        this.getViewDoc(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            // console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        // console.log("logError ", error);
        reject(error);
      }
    });
  }
  downloadFormalisationReport() {
    return new Promise((resolve, reject) => {
      try {
        const apiName = COMMON.DOWNLOAD_FORMALISATION_REPORT;
        this.getViewDoc(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            // console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        // console.log("logError ", error);
        reject(error);
      }
    });
  }

  getFormalisationData() {
    return new Promise((resolve, reject) => {
      try {
        const apiName = COMMON.GET_FORMALISATION_DATA;
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            // console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        // console.log("logError ", error);
        reject(error);
      }
    });
  }
  downloadLandingBankReportGroup() {
    return new Promise((resolve, reject) => {
      try {
        let apiName = COMMON.DOWNLOAD_LANDING_BANK_REPORT_GROUP;
        this.getViewDoc(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            // console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        // console.log("logError ", error);
        reject(error);
      }
    });
  }

  downloadReport() {
    return new Promise((resolve, reject) => {
      try {
        let apiName = COMMON.DOWNLOAD_REPORT;
        this.getViewDoc(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            // console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        //console.log("logError ", error);
        reject(error);
      }
    });
  }

  downloadReportNonInd() {
    return new Promise((resolve, reject) => {
      try {
        let apiName = COMMON.DOWNLOAD_REPORT_NON_IND;
        this.getViewDoc(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            //  console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        //  console.log("logError ", error);
        reject(error);
      }
    });
  }

  uploadDoc(newObj, file) {
    return new Promise((resolve, reject) => {
      try {
        let apiName =
          "api/digitization/uploadDocument/" +
          newObj.applicationId +
          "/" +
          newObj.docCode;
        this.postDocument(apiName, newObj, file).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  uploadDataWithFile(data, file) {
    return new Promise((resolve, reject) => {
      try {
        // let apiName = 'api/digitization/uploadDocument/' + newObj.applicationId + '/' + newObj.docCode;
        const apiName = COMMON.SAVE_DETAILS_OF_USER;
        this.postDocumentWithData(apiName, data, file).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  searchApplication(applicationNo) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = COMMON.SEARCH_APPLICATION + applicationNo;
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            //console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        //console.log("logError ", error);
        reject(error);
      }
    });
  }
  widrawApplication(obj) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = "api/application/widrawApplication";
        this.postCall(apiName, obj).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  getApplicationDetailsDraft(reqObj) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = COMMON.GET_APPLICATION_DETAILS_V2;
        this.postCall(apiName, reqObj).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            // console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        //console.log("logError ", error);
        reject(error);
      }
    });
  }

  applicationStatusReport(obj) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = "api/kpi/applicationStatusReport";
        this.postViewDoc(apiName, obj).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  applicationStatusReportV2(obj) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = "api/reports/getApplicationStatusReportV2";
        this.postViewDoc(apiName, obj).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }
  downloadIndAndGroupStatusReports(obj){
    return new Promise((resolve, reject) => {
      try {
        let apiName = "api/reports/downloadIndAndGroupStatusReport";
        this.postViewDoc(apiName, obj).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }
  getDistricts(stateId) {
    return new Promise((resolve, reject) => {
      try {
        const apiName = "api/master/getDistricts" + "/" + stateId;
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  getBlock(districtId) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = "api/master/getBlocks" + "/" + districtId;
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  geHoSideMenuData() {
    return new Promise((resolve, reject) => {
      try {
        const apiName = "api/application/getAllBackInternalHoRole" + "/";
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  getApplicantsCategory() {
    return new Promise((resolve, reject) => {
      try {
        const apiName = "api/master/getApplicantsCategory";
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  getDocumentType(usedFor, refType) {
    return new Promise((resolve, reject) => {
      try {
        const apiName = "api/master/getDocumentType/" + usedFor + "/" + refType;
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  getUploadedDocumentList(id) {
    return new Promise((resolve, reject) => {
      try {
        const apiName = "api/master/getDistricts" + "/" + id;
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  getDocumentList(applicationId) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = "api/digitization/getDocumentList/" + applicationId;
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  getUploadedDocument(id) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = COMMON.GET_UPLOADED_DOCUMENT + id;
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            //console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        //console.log("logError ", error);
        reject(error);
      }
    });
  }

  deleteDocument(documentId) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = "api/digitization/deleteDocument/" + documentId;
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  getAppSubCategory(applicantCategoryId) {
    return new Promise((resolve, reject) => {
      try {
        const apiName =
          "api/master/getAppSubCategory" + "/" + applicantCategoryId;
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  getSmsDataFromApplication(applicationNumber) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = COMMON.GET_UPLOADED_DOCUMENT + applicationNumber;
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            //console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        //console.log("logError ", error);
        reject(error);
      }
    });
  }

  getSanctionedButNotDisbursedData() {
    return new Promise((resolve, reject) => {
      try {
        const apiName = COMMON.GET_SANCTIONED_BUT_NOT_DISBURSED_DATA;
        this.getCall(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            // console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        // console.log("logError ", error);
        reject(error);
      }
    });
  }

  getSanctionedButNotDisbursedDataHo(body: any) {
    return new Promise((resolve, reject) => {
      try {
        const apiName = COMMON.GET_SANCTIONED_BUT_NOT_DISBURSED_DATA_HO;
        this.postCall(apiName, body).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            // console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        // console.log("logError ", error);
        reject(error);
      }
    });
  }

  downloadSanctionedButNotDisbursedData() {
    return new Promise((resolve, reject) => {
      try {
        let apiName = COMMON.DOWNLOAD_SANCTIONED_BUT_NOT_DISBURSED_DATA;
        this.getViewDoc(apiName).subscribe(
          (data) => {
            if (data != null && data != undefined) {
              resolve(data);
            } else {
              reject();
            }
          },
          (error) => {
            // console.log("logInnerError ", error);
            reject(error);
          }
        );
      } catch (error) {
        // console.log("logError ", error);
        reject(error);
      }
    });
  }
}
